import { render } from "./2023Results.vue?vue&type=template&id=da1ddc62&scoped=true"
import script from "./2023Results.vue?vue&type=script&lang=js"
export * from "./2023Results.vue?vue&type=script&lang=js"

import "./2023Results.vue?vue&type=style&index=0&id=da1ddc62&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shawn\\sloppy-golf\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da1ddc62"]])

export default __exports__